import { render, staticRenderFns } from "./RecentBlogs.vue?vue&type=template&id=49c1a6f6&"
import script from "./RecentBlogs.vue?vue&type=script&lang=js&"
export * from "./RecentBlogs.vue?vue&type=script&lang=js&"
import style0 from "./RecentBlogs.vue?vue&type=style&index=0&id=49c1a6f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports